import { forwardRef, useImperativeHandle } from 'react'
import { useCommands } from '@remirror/react'

const RefMaintainer = forwardRef((_props, ref) => {
  const commands = useCommands()
  useImperativeHandle(
    ref,
    () => ({
      focus() {
        commands.focus()
      }
    }),
    [commands]
  )
  return null
})

export default RefMaintainer
